export const CHECK_STATUS_TYPE_UN_CHECK = '未质检';
export const CHECK_STATUS_TYPE_PASSED = '质检通过';
export const CHECK_STATUS_TYPE_PARTIAL_PASSED = '部分通过';
